import { render, staticRenderFns } from "./ProgramApproval.vue?vue&type=template&id=504881aa"
import script from "./ProgramApproval.vue?vue&type=script&lang=ts"
export * from "./ProgramApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports